import { render, staticRenderFns } from "./BtnAtualizarValoresEmLoteDetalhesFase.vue?vue&type=template&id=05d382e1"
import script from "./BtnAtualizarValoresEmLoteDetalhesFase.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarValoresEmLoteDetalhesFase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports